export const adminNavs = [];

export const blueprintIcon = (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.25004V59.0001C12.0001 59.6546 12.5955 60.2501 13.25 60.2501H50.75C51.4045 60.2501 51.9999 59.6546 52 59.0001V17.75C52 17.4173 51.8656 17.0856 51.6289 16.8516L39.1289 4.3516C38.8963 4.1266 38.5736 3.99754 38.25 4.00004H13.25C12.5432 4.00629 12.0154 4.68697 12 5.25004ZM14.5 6.50004H37V17.75C37.0001 18.4045 37.5955 19 38.25 19H49.5V57.7501H14.5V6.50004ZM39.5 8.25785L47.7422 16.5H39.5V8.25785Z"
      fill="black"
    />
    <path
      d="M34.7318 25.875C34.2351 25.875 33.7798 26.2882 33.7798 26.8254V35.0898C33.7798 35.5856 34.1937 36.0402 34.7318 36.0402H43.5895C43.8379 36.0402 44.0862 35.9162 44.2518 35.7509C44.4174 35.5443 44.5002 35.2964 44.5002 35.0485C44.169 29.8832 39.8643 25.875 34.7318 25.875ZM35.6424 27.7758C39.0779 28.189 41.8511 30.751 42.5134 34.1394H35.6424V27.7758Z"
      fill="black"
    />
    <path
      d="M41.396 37.9H32.1658V29.0158C32.1658 28.5199 31.7519 28.1067 31.2552 28.1067C31.131 28.1067 31.0068 28.1067 30.8826 28.1067C24.5911 28.0653 19.5 33.1893 19.5 39.4702C19.5 45.7511 24.6325 50.875 30.924 50.875C37.2155 50.875 42.3481 45.7511 42.3481 39.4702C42.3481 39.2223 42.3481 38.9743 42.3067 38.7677C42.3067 38.2719 41.8927 37.9 41.396 37.9ZM30.924 49.0155C25.6259 49.0155 21.3626 44.7594 21.3626 39.4702C21.3626 34.4289 25.3362 30.2554 30.3445 29.9662V38.809C30.3445 39.3049 30.7585 39.7594 31.2965 39.7594H40.5268C40.3613 44.8833 36.0979 49.0155 30.924 49.0155Z"
      fill="black"
    />
  </svg>
);
